module.exports = __webpack_public_path__ + "static/media/Grafismo.813ae2f2.png";